import React from 'react';
import style from './index.scss';
import { Icon } from 'js/components/common/Icon';

export default ({ t }) => (
    <div className={style.actionButtons}>
        <span className={style.backBtn} onClick={() => window.history.back()}>
            <Icon type="back_arrow_gi" className={style.backBtnIcon} />
            <span className={style.backBtnText}>{t('playtech.mobile.system.games.backToGame')}</span>
        </span>
    </div>
);
